import { useEffect, useState } from "react";
import Content from "./content";
import ContentLayout from "../../layout/contentLayout";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import StackKit from "@/shared/components/kit/stack";
import ContentTransactions from "./contentTransactions";
import ContentChart from "./contentChart";
import RedeemIcon from "@mui/icons-material/Redeem";
import CustomButton from "@/shared/components/kit/button";
import AddIcon from "@mui/icons-material/Add";
import AlertDialog from "@/shared/components/kit/modal";
import ContentModal from "./contentModal";
import ContentModalPayment from "./contentModalPayment";
import { fetchListListMerchantName } from "../../../../api/merchant/request.get";
import { useMutation, useQuery } from "@tanstack/react-query";
import {fetchChartGiftPazirande,fetchChartGiftPazirandeBar,fetchDetailsGiftPazirande,fetchpayment,} from "@/api/merchant/request.post";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { Grid } from "@mui/material";
import { WidthFull } from "@mui/icons-material";
/**
 * InternalReportsInventory
 *
 * کامپوننت اصلی برای نمایش گزارش‌های داخلی مربوط به موجودی هدیه (هدیه).
 * شامل بخش‌های مختلفی از جمله تراکنش‌ها، نمودارها، و مودال افزایش موجودی است.
 * این نسخه به‌صورت کامل واکنش‌گرا طراحی شده و در دستگاه‌های مختلف چیدمان سازگار ارائه می‌دهد.
 *
 * ویژگی‌ها:
 * - نمایش موجودی هدیه و تراکنش‌های مرتبط
 * - نمودار تحلیلی موجودی هدیه به‌صورت هفتگی، ماهانه، و سالانه
 * - مودال افزایش موجودی و درگاه پرداخت
 * - طراحی واکنش‌گرا برای موبایل، تبلت و دسکتاپ
 *
 * @component
 * @returns JSX.Element
 */


const InternalReportsInventory = () => {
  const [selectedMerchantCode, setSelectedMerchantCode] = useState<any>({});
  const [listIncreaseGift, setListIncreaseGift] = useState<any>([]);
  const [activeTab, setActiveTab] = useState("weekly");

  const [listIncreaseGiftChart, setListIncreaseGiftChart] = useState<any>([]);
  const [listIncreaseGiftChartBar, setListIncreaseGiftChartBar] = useState<any>();

  const [amountState, setAmountState] = useState("");

  const [selectedOption, setSelectedOption] = useState<string>("option1");

  const [selectedImage, setSelectedImage] = useState<any>({ id: 1, title: "fanava", img: "/fanavar.png", name: "فن آوا" });

  const {
    data: dataListMerchantName,
    isFetched,
    isLoading,
    refetch
  } = useQuery({
    queryKey: ["ListList-data"],
    queryFn: fetchListListMerchantName
  });

  const { mutate: submitForm } = useMutation({
    mutationFn: (body: any) => fetchDetailsGiftPazirande(body),
    onSuccess: (data: any) => {
      setListIncreaseGift(data?.data?.list_increase_gift);
    },
    onError: (error: AxiosError<{ message: string }>) => {
      toast.error(error?.response?.data?.message || "خطا در ثبت اطلاعات");
    }
  });

  const { mutate: submitFormGiftPazirande } = useMutation({
    mutationFn: (body: any) => fetchChartGiftPazirande(body),
    onSuccess: (data: any) => {
      setListIncreaseGiftChart(data?.data?.chart);
    },
    onError: (error: AxiosError<{ message: string }>) => {
      toast.error(error?.response?.data?.message || "خطا در ثبت اطلاعات");
    }
  });

  const { mutate: submitFormGiftPazirandeBar } = useMutation({
    mutationFn: (body: any) => fetchChartGiftPazirandeBar(body),
    onSuccess: (data: any) => {
      setListIncreaseGiftChartBar(data?.data);
    },
    onError: (error: AxiosError<{ message: string }>) => {
      toast.error(error?.response?.data?.message || "خطا در ثبت اطلاعات");
    }
  });

  const { mutate: submitFormGiftPayment, isPending } = useMutation({
    mutationFn: (body: any) => fetchpayment(body),
    onSuccess: (data: any) => {
      window.location.href = data?.data?.url;
    },
    onError: (error: AxiosError<{ message: string }>) => {
      toast.error(error?.response?.data?.message || "خطا در پرداخت");
    }
  });

  useEffect(() => {
    const pazirandeNumber = dataListMerchantName?.userInfo?.pazirande_number;

    if (typeof pazirandeNumber === "string" && pazirandeNumber.trim()) {
      const requestBody: any = {
        pazirande_number: pazirandeNumber,
        type: "yearly"
      };

      const requestBodyGiftPazirande: any = {
        pazirande_number: pazirandeNumber,
        type: activeTab
      };

      setSelectedMerchantCode(requestBody);
      submitForm(requestBody);
      submitFormGiftPazirande(requestBodyGiftPazirande);
      submitFormGiftPazirandeBar(requestBodyGiftPazirande);
    }
  }, [dataListMerchantName]);

  const [isModalGift, setIsModalGift] = useState(false);
  const [isModalPayment, setIsModalPayment] = useState(false);

  // Open first modal (enter amount)
  const handleOpenModal = () => {
    setIsModalGift(true);
  };

  // After confirming amount → open payment gateway modal
  const handleClickPayment = () => {
    setIsModalGift(false);
    setTimeout(() => {
      setIsModalPayment(true);
    }, 100);
  };

  // Final payment action
  const handleClickPaymentUser = () => {
    const requestBody = {
      payment_type_id: 4,
      gateway: selectedImage?.title,
      fee: amountState
    };

    if (selectedOption !== "option1") {
      submitFormGiftPayment(requestBody);
    }
  };

  return (
    <>
      {/* Header Section */}
      <StackKit
        direction={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", sm: "center" }}
        sx={{
          width: "100%",
          gap: { xs: 2, sm: 0 },
          mb: { xs: 2, md: 3 }
        }}
      >
        <StackKit direction="row" alignItems="center" gap={1} sx={{ flexWrap: "wrap" }}>
          <RedeemIcon fontSize="small" />
          <TypoGraphyKit variant="h6">موجودی  هدیه</TypoGraphyKit>
        </StackKit>

        <CustomButton
          sx={{
            bgcolor: "#800101",
            display: "flex",
            justifyContent: "space-between",
            px: 2,
            py: 1,
            mt: { xs: 1, sm: 0 },
            alignSelf: { xs: "stretch", sm: "auto" }
          }}
          onClick={handleOpenModal}
        >
          <TypoGraphyKit
            variant="body1"
            sx={{ fontSize: { xs: "0.9rem", sm: "1rem" }, textAlign: "center" }}
          >
            افزایش موجودی هدیه
          </TypoGraphyKit>
          <AddIcon style={{ color: "#fff" }} />
        </CustomButton>
      </StackKit>

      {/* Main Content */}
      <Grid container  spacing={2}>
        <Grid size={{ xs: 12 }}>
          <Content listIncreaseGift={listIncreaseGift} />
        </Grid>

        <Grid size={12}>
          <ContentLayout size={12} sx={{ width: "100%" }}>
            <ContentTransactions listIncreaseGift={listIncreaseGift} />
          </ContentLayout>
        </Grid>

        <Grid size={{ xs: 12 }}>
          <ContentLayout isContainerFluid isPadding>
            <ContentChart
              listIncreaseGiftChartBar={listIncreaseGiftChartBar}
              setActiveTab={setActiveTab}
              activeTab={activeTab}
              listIncreaseGiftChart={listIncreaseGiftChart}
              handleOpenModal={handleOpenModal}
            />
          </ContentLayout>
        </Grid>
      </Grid>

      {/* Modal 1: Amount */}
      <AlertDialog
        onClose={() => setIsModalGift(false)}
        open={isModalGift}
        isHeader
        header={<TypoGraphyKit variant="h6">افزایش موجودی هدیه پذیرنده</TypoGraphyKit>}
        disagreeText="بستن"
        agreeText="پرداخت"
        onAgree={handleClickPayment}
        disabled={amountState === ""}
      >
        <ContentModal amountState={amountState} setAmountState={setAmountState} />
      </AlertDialog>

      {/* Modal 2: Gateway + Image Selection */}
      <AlertDialog
        onClose={() => setIsModalPayment(false)}
        open={isModalPayment}
        isHeader
        header={<TypoGraphyKit variant="h6">افزایش موجودی هدیه پذیرنده</TypoGraphyKit>}
        onDisagree={() => setIsModalPayment(false)}
        disagreeText="بستن"
        agreeText="پرداخت"
        onAgree={handleClickPaymentUser}
      >
        <ContentModalPayment
          setSelectedOption={setSelectedOption}
          selectedOption={selectedOption}
          setSelectedImage={setSelectedImage}
          selectedImage={selectedImage}
        />
      </AlertDialog>
    </>
  );
};

export default InternalReportsInventory;
